// GENERATED by npm run generate-graphql-operations
const AddSeedToStation = 'mutation AddSeedToStationWeb($stationId: String!, $seedId: String!) {   addStationSeed(stationId: $stationId, seedId: $seedId) {     status   } } ';
export default AddSeedToStation;
